interface IStaticAssetsIconProps {
  className?: string;
}

/**
 * A framed picture with an upload arrow rising out of it — the tool is "put
 * files on the CDN", so the icon is an image asset on its way up. Monoline,
 * `currentColor`, no fills, 48×48 grid like the other tool icons.
 */
const StaticAssetsIcon = ({ className }: IStaticAssetsIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* picture frame */}
    <rect x="7" y="11" width="34" height="28" rx="2" />
    {/* sun */}
    <circle cx="16" cy="20" r="3" />
    {/* hills */}
    <path d="M7 34 l10 -9 l7 6 l6 -5 l11 8" />
    {/* upload arrow breaking the top edge */}
    <path d="M33 16 v-11" />
    <path d="M29 9 l4 -4 l4 4" />
  </svg>
);

export default StaticAssetsIcon;
